import React, { createContext, useContext } from 'react';
import { MarketplaceEnum } from './types';
import { useSelector } from 'react-redux';
import { FALLBACK_MARKETPLACE } from '../../constants';
const MarketplaceContext = createContext({ marketplace: MarketplaceEnum.fr });
export function MarketplaceProvider({ children, marketplaceOverrideForStorybook }) {
    const storeMarketplace = useSelector((state) => { var _a; return (_a = state.tolgee) === null || _a === void 0 ? void 0 : _a.marketplace; }) || FALLBACK_MARKETPLACE;
    const marketplace = marketplaceOverrideForStorybook !== null && marketplaceOverrideForStorybook !== void 0 ? marketplaceOverrideForStorybook : storeMarketplace;
    return React.createElement(MarketplaceContext.Provider, { value: { marketplace } }, children);
}
export function useMarketplace(marketplaces) {
    const context = useContext(MarketplaceContext);
    if (!context) {
        throw new Error('useMarketplace must be used within MarketplaceProvider');
    }
    const isInTargetMarkets = marketplaces ? marketplaces.includes(context.marketplace) : true;
    return Object.assign(Object.assign({}, context), { isInTargetMarkets });
}
